import { useEffect, useState } from "react";
export type Page =
  | "home"
  | "discover"
  | "messages"
  | "profile"
  | "search"
  | "collection"
  | "settings"
  | "create"
  | "publish";
export type Overlay =
  | "categories"
  | "episodes"
  | "comments"
  | "share"
  | "auth"
  | "edit"
  | "chat"
  | "notice"
  | null;
export type Navigation = { page: Page; overlay: Overlay };
const pages: Page[] = [
  "home",
  "discover",
  "messages",
  "profile",
  "search",
  "collection",
  "settings",
  "create",
  "publish",
];
export function useNavigation() {
  const [nav, setNav] = useState<Navigation>(() => ({
    page: pages.includes(location.hash.slice(1) as Page)
      ? (location.hash.slice(1) as Page)
      : "home",
    overlay: null,
  }));
  useEffect(() => {
    history.replaceState({ frameNav: nav, frameDepth: 0 }, "", `#${nav.page}`);
    const pop = (event: PopStateEvent) =>
      setNav(event.state?.frameNav || { page: "home", overlay: null });
    const hash = () => {
      const page = location.hash.slice(1) as Page;
      if (pages.includes(page) && history.state?.frameNav?.page !== page) {
        const next = { page, overlay: null };
        history.replaceState({ frameNav: next, frameDepth: 0 }, "", `#${page}`);
        setNav(next);
      }
    };
    window.addEventListener("popstate", pop);
    window.addEventListener("hashchange", hash);
    return () => {
      window.removeEventListener("popstate", pop);
      window.removeEventListener("hashchange", hash);
    };
  }, []);
  function navigate(page: Page, overlay: Overlay = null) {
    const next = { page, overlay };
    if (page === nav.page && overlay === nav.overlay) return;
    history.pushState(
      { frameNav: next, frameDepth: (history.state?.frameDepth || 0) + 1 },
      "",
      `#${page}`,
    );
    setNav(next);
  }
  function replace(page: Page) {
    const next = { page, overlay: null };
    history.replaceState(
      { frameNav: next, frameDepth: history.state?.frameDepth || 0 },
      "",
      `#${page}`,
    );
    setNav(next);
  }
  function back() {
    if ((history.state?.frameDepth || 0) > 0) history.back();
    else if (nav.overlay || nav.page !== "home") replace("home");
  }
  return { nav, navigate, replace, back };
}
